module.exports = __webpack_public_path__ + "static/media/alarm_category_management.0ef91fbc.svg";